import React from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import VideoBackground from './components/VideoBackground';
import SnowfallEffect from './components/SnowfallEffect';
import RegistrationForm from './components/RegistrationForm';

function App() {
  return (
    <div className="relative min-h-screen overflow-x-hidden bg-gray-950">
      <VideoBackground />
      <SnowfallEffect />
      
      <Header />
      
      <main className="relative z-20">
        <section className="min-h-screen flex items-center justify-center px-4 py-20">
          <div className="container mx-auto max-w-4xl">
            
            {/* Clean Minimal Header */}
            <motion.div 
              className="text-center mb-12"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
            >
              
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6">
                <span className="block">WINTER</span>
                <span className="block bg-gradient-to-r from-blue-400 via-cyan-300 to-blue-500 bg-clip-text text-transparent">
                  STARTUP SPRINT
                </span>
              </h1>
              
            </motion.div>

            {/* Clean Form Container */}
            <motion.div
              className="relative"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3 }}
            >
              <motion.div
                className="backdrop-blur-xl bg-white/5 rounded-2xl border border-white/10 shadow-xl overflow-hidden"
                whileHover={{ boxShadow: "0 20px 40px rgba(0, 0, 0, 0.3)" }}
              >
                
                
                {/* Form Content */}
                <div className="p-8">
                  <RegistrationForm />
                </div>
              </motion.div>
            </motion.div>
            
          </div>
        </section>
      </main>
    </div>
  );
}

export default App;